import { Grid, LinearProgress, List, ListItem, ListItemText, Paper } from "@mui/material";
import { useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { PrimaryButton } from "../../_components/button/primary.button";
import PaperHeading from "../../_components/typography/paperHeading";
import { UserAddressManage } from "./user-addressManage";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { formService } from "../../_services/form.service";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";

export function UserCompetitionLicenseApplicationCreate() {

    const { userId } = useParams<{ userId: string }>();
    const [isLoading, setIsLoading] = useState(false);
    let navigate = useNavigate();

    function createForm() {
        return formService.createByType(FormTemplateTypeEnum.CompetitionLicenceApplication, (userId || ""))
            .then(
                (id: number) => {
                    navigate(`../../Forms/${id}`);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <ValidatorForm
            onSubmit={() => console.log("test")}
            noValidate>
            <Grid container>
                <Grid item xs={12}>
                    <h2 style={{ textAlign: "center" }}>Competition Licence Application</h2>

                    {isLoading && <LinearProgress color="secondary" />}

                    {!isLoading && <>
                        <Paper>
                            <PaperHeading>Have You?</PaperHeading>
                            <List sx={{ listStyle: "decimal", pl: 4 }}>
                                <ListItem sx={{ display: "list-item" }}>
                                    <ListItemText primary="Verified that all of your personal and contact information is correct? If you have not filled in all address fields, including City, Country and Postal Code, you will not be able to make a payment online" />
                                </ListItem>
                                <ListItem sx={{ display: "list-item" }}>
                                    <ListItemText primary="Uploaded a profile picture below? This will be the image that will appear on your licence card. " />
                                </ListItem>
                                <ListItem sx={{ display: "list-item" }}>
                                    <ListItemText primary="Uploaded proof of Club Membership below. If you are not a member of an affiliated motor club you will have to pay the non-member fee of €275." />
                                </ListItem>
                            </List>
                        </Paper>

                        <Paper>
                            <PaperHeading>Please ensure ALL address fields below have been filled in (Including City & Postal Code):</PaperHeading>
                            <UserAddressManage />
                        </Paper>

                        <Paper style={{ "marginTop": "8px" }}>
                            <PrimaryButton
                                type="button"
                                variant="primary"
                                disabled={isLoading}
                                onClick={createForm}>

                                Start application
                            </PrimaryButton>
                        </Paper>
                    </>
                    }
                </Grid>
            </Grid >
        </ValidatorForm >

    );

}
